import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

import { countriesLinks, HDIRatingLabels, instructions } from '../consts';
import { AugmentedTimeZoneWithCountryData } from '../types';
import { LocalTzTime } from '../LocalTzTime';
import { amplitudeService } from 'services';
import { HDIinfoIcon } from 'icons';

export const MobileResultsList = ({
  data,
}: {
  data: AugmentedTimeZoneWithCountryData[];
}) => {
  return (
    <Box>
      {data.map((row) => (
        <Paper
          sx={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '20px',
          }}
          key={row.tzNameLabel}
        >
          <Box sx={{ padding: '16px' }}>
            <Box display="flex" flexDirection="row">
              <Box
                sx={{
                  fontSize: '46px',
                  filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15))',
                }}
                className={`fi fi-${row.country.id.toLowerCase()}`}
              />
              <Box
                display="flex"
                flexDirection="column"
                sx={{ paddingLeft: '20px' }}
              >
                <Typography fontWeight={500} variant="textMedium">
                  {row.country.name}
                </Typography>
                <Typography variant="textSmall" fontWeight={500}>
                  {row.tzNameLabel}
                </Typography>
              </Box>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              sx={{ paddingTop: '20px' }}
            >
              <Typography fontWeight={500} color="grey.300" variant="textSmall">
                Overlap:
              </Typography>

              <Box display="flex" alignItems="center">
                <Typography
                  fontWeight={500}
                  variant="textMedium"
                  sx={{ marginRight: '30px' }}
                >
                  {row.overlapInHours} hours
                </Typography>

                <LocalTzTime offset={row.tzData.offset()} />
              </Box>
              <Typography
                fontWeight={500}
                color="grey.300"
                variant="textSmall"
                sx={{ marginTop: '20px' }}
              >
                <Tooltip title={instructions} placement="top">
                  <Box>
                    <Box display="inline-block" paddingRight="4px">
                      <HDIinfoIcon />
                    </Box>
                    Human Development Index:
                  </Box>
                </Tooltip>
              </Typography>
              <Typography variant="textMedium" fontWeight={500}>
                {HDIRatingLabels[row.HDIData?.rating ?? ''] ?? 'N/A'}
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              sx={{ paddingTop: '20px' }}
            >
              <Button
                variant="contained"
                href={row.costCalcData.url}
                target="_blank"
              >
                Calculate employment cost
              </Button>
              {row.hiringGuidesData.url && (
                <Button
                  sx={{ marginTop: '10px' }}
                  variant="outlined"
                  href={row.hiringGuidesData.url}
                  target="_blank"
                  onClick={() => {
                    const mappedCountryName = countriesLinks[row.country.name];
                    mappedCountryName &&
                      amplitudeService.logHiringGuidesClick(mappedCountryName);
                  }}
                >
                  Hiring guide
                </Button>
              )}
            </Box>
          </Box>
        </Paper>
      ))}
    </Box>
  );
};
